import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  badge?: { text: string; tone?: 'info' | 'warning' | 'success' | 'neutral' };
  actions?: React.ReactNode;
}

// 统一的一级页面头部：标题 + 一行副标题 + 右侧操作区
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, badge, actions }) => {
  return (
    <div className="page-header">
      <div className="page-header-row">
        <div className="page-header-heading">
          <h2>{title}</h2>
          {badge && (
            <span className={`status-badge ${badge.tone || 'info'}`}>{badge.text}</span>
          )}
        </div>
        {actions && <div className="page-header-actions">{actions}</div>}
      </div>
      {subtitle && <p className="page-subtitle">{subtitle}</p>}
    </div>
  );
};

export default PageHeader;
